export default "__VITE_ASSET__923233e6__"